import { modalActions } from 'actions/V4Actions/v4ActionModal';
export default function (state = {}, action) {
    switch (action.type) {
        case modalActions.HANDLE_MODAL_ACTION:
            return action;
        case modalActions.CLEAR_MODAL_ACTION:
            return {};
        default:
            return state;
    }
}
